'use strict';
import {ReduxItem} from '../../../_libs/redux-observable-list/index';
import {buildInstanceSyncNotifier} from '../../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../../config/redux-list/index';
import {ReduxRouterState} from '../../../core-utilities/redux-ui-router-utils/index';
import {projectTasksStates} from '../../../tasks/router-config';
import {FORM_REQUIREMENT_COLLECTION} from '../../domain/config';
import {getProjectFormRequirement} from '../../reducers/state';
import {projectFormRequirementStates} from '../../router-config';
import {logger} from '../logger';
import {PROJECT_FORM_ITEM_PREFIX} from '../state';


export const itemPath = id => `${FORM_REQUIREMENT_COLLECTION}/${id}`;

/** @type {ReduxObservableItemOptions} */
const reduxItemOptions = {
  prefix: PROJECT_FORM_ITEM_PREFIX,
  crossDomain: BASE_REDUX_LIST_OPTIONS.crossDomain,
  getToken: BASE_REDUX_LIST_OPTIONS.getToken,
  baseApiUrl: BASE_REDUX_LIST_OPTIONS.baseApiUrl,
  baseServerUrl: BASE_REDUX_LIST_OPTIONS.baseServerUrl,
  getState: getProjectFormRequirement,
  itemPath,
  itemSyncPath: itemPath,
  syncNotifier: buildInstanceSyncNotifier(FORM_REQUIREMENT_COLLECTION),

  logger,
};

export const projectFormRequirementReduxItem = new ReduxItem(reduxItemOptions);

/** @type {ReduxRouterStateOptions} */
const routerStateOptions = {
  idParam: 'requirementId',
  stateNames: Object.values(projectFormRequirementStates),
  noDataMessage: 'state.no.requirement.message',
  fallbackStateName: projectTasksStates.requirements,
  reduxItem: projectFormRequirementReduxItem,
  logger,
};

export const projectFormRequirementRouterState = new ReduxRouterState(routerStateOptions);



// WEBPACK FOOTER //
// ./src/js/requirements/redux/forms/projectFormRequirementRouterState.js